import {LogrosSchema} from '@cnc/contracts';
import {useMutation, useQuery, useQueryClient} from '@tanstack/react-query';
import {z} from 'zod';
import {pedir} from './cliente';

// Logros de los exportadores: se revisan cada pocos minutos para avisar los nuevos.
export function useLogros() {
  return useQuery({
    queryKey: ['logros'],
    queryFn: () => pedir('logros', LogrosSchema),
    refetchInterval: 5 * 60_000,
  });
}

export function useMarcarLogrosVistos() {
  const cliente = useQueryClient();
  return useMutation({
    mutationFn: (hasta: number) =>
      pedir('logros/vistos', z.unknown(), {
        method: 'POST',
        headers: {'content-type': 'application/json'},
        body: JSON.stringify({hasta}),
      }),
    onSuccess: () => cliente.invalidateQueries({queryKey: ['logros']}),
  });
}
